import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { HospitalService } from '../_services';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss']
})
export class SocialMediaComponent implements OnInit, OnDestroy {
  language: any;
  HospitalContacts;
  isLoading$: Observable<boolean>;
  WhatsAppNo;
  private subscriptions: Subscription[] = [];
  constructor(private HospitalService: HospitalService, private translationService: TranslationService) { }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    const sb = this.HospitalService.GetHospitalContacts().subscribe(res => {
      if (res.data != null && res.isSuccess) {
        this.HospitalContacts = res.data;
        this.WhatsAppNo ="https://api.whatsapp.com/send/?phone="+res.data.whatsappNumberEn+"&text&type=phone_number&app_absent=0";
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

}
